import React from "react";
import HomeMetaData from "../../Utils/HomeMetaData";
import HeroSlider from "../../Component/HeroCMPT/HeroSlider";
// import ServiceSectionHome from "../../Component/ServiceCMPT/ServiceSectionHome";
import AboutSectionHome from "../../Component/AboutCMPT/AboutSectionHome";
// import CounterSection from "../../Component/CounterSection/CounterSection";
import WhyChooseUsSection from "../../Component/WhyChooseUs/WhyChooseUsSection";
import BlogSectionHome from "../../Component/BlogsCMPT/BlogSectionHome";
import RequestQuateSection from "../../Component/RequestQuateSection";
import AboutSection2Home from "../../Component/AboutCMPT/AboutSection2Home";

export default function Home() {
  return (
    <>
      <HomeMetaData />
      {/* Hero Slider  */}
      <HeroSlider />
      {/* <ServiceSectionHome /> */}
      <AboutSectionHome />
      <AboutSection2Home />
      {/* <CounterSection /> */}
      <WhyChooseUsSection />
      <BlogSectionHome />

      <RequestQuateSection />
    </>
  );
}
